<mat-form-field class="w-100" appearance="outline">
    <mat-label>{{ label | translate }}</mat-label>

    <input currencyMask matInput 
        [options]="{
            prefix: prefix ? prefix + ' ' : '',
            suffix: suffix ? ' ' + suffix : '',
            thousands: '.',
            decimal: ',',
            align: 'left',
            precision: digits,
            nullable: true
        }"
        [formControlName]="fieldName"
        [required]="required">

    <mat-error *ngIf="getError() === 'required'">
        {{ 'data-table.modal.validation-error.field-required' | translate }}
    </mat-error>
    
    <mat-error *ngIf="getError() === 'min'">
        {{ 'data-table.modal.validation-error.min' | translate : { min: getFormControlField()?.getError('min')['min'] } }}
    </mat-error>
    
    <mat-error *ngIf="getError() === 'max'">
        {{ 'data-table.modal.validation-error.max' | translate : { max: getFormControlField()?.getError('max')['max'] } }}
    </mat-error>
    
    <mat-error *ngIf="getError() === 'multiple'">
        {{ 'data-table.modal.validation-error.multiple' | translate : { multiple: getFormControlField()?.getError('multiple')['multiple'] } }}
    </mat-error>
</mat-form-field>
